import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Order Confirmation Header Wrapper',
  showEmpty: true,
  render: View,
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {},
  },
  fields: {children: TListOfElement},
});

export default config;
